var _style, _line, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 101.1 101.4",
    style: {
      enableBackground: "new 0 0 101.1 101.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:url(#SVGID_1_);stroke-width:11.55;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:url(#SVGID_00000176755412754767176360000015224834558991700638_);stroke-width:11.55;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#231F20;stroke-width:2.31;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.3745,
    y1: 53.073,
    x2: 87.7745,
    y2: 53.073,
    gradientTransform: "matrix(1 0 0 -1 0 103.766)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF935E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#C49F62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#A77734"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DAC786"
    }
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.4,
    y1: 50.7,
    x2: 87.8,
    y2: 50.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045582947391701041800000008755978204670007989_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.3745,
    y1: 53.073,
    x2: 87.7745,
    y2: 53.073,
    gradientTransform: "matrix(6.123234e-17 1 1 -6.123234e-17 -2.4985 0.1185)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AF935E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#C49F62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#A77734"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DAC786"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000045582947391701041800000008755978204670007989_)",
      strokeWidth: 11.55,
      strokeMiterlimit: 10
    },
    x1: 50.6,
    y1: 13.5,
    x2: 50.6,
    y2: 87.9
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 50.6,
    cy: 50.7,
    r: 49.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.49fc0c1920073330d7b7cf3bd97a193d.svg";
export { ForwardRef as ReactComponent };